import { themeColors } from "../../../themeColors";
/**
 * @file   src\mobile\components\Messages\IntroductionDetails.js
 * @brief  This file is responsible for dhowing introduction details.
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState, useEffect } from "react";
import AgentProfileInfoModal from "../ReceiveIntroduction/AgentProfileInfoModal";
import ExpiredModal from "../ReceiveIntroduction/ExpiredModal";
import "../../styles/clients.scss";
import {
  AGENT_USER_MONTHLY_PRO_MEMBER,
  AGENT_USER_YEARLY_PRO_MEMBER,
  INTRODUCTION_EXPIRATION_TIME,
  INVENTORY_LAND,
  INVENTORY_LTR,
  INVENTORY_LTR_STR,
  INVENTORY_PURPOSE,
  INVENTORY_SELL,
  INVENTORY_SELL_LTR,
  INVENTORY_SELL_STR,
  INVENTORY_STR,
  IS_LAND,
  USER_TYPE_AGENT,
} from "../../../constants/common";
import { getIntroductionInventoryDetailsById } from "../../../services/introductionService";
import { getPropertyPurpose, getUserId } from "../../../helpers/common";
import { convertToNumber } from "../../../helpers/validations";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { pageURLs } from "@/constants";
import {
  buildReceiveIntroMustHaveHtmlForMobile,
  buildSchoolNeigborhoodHtmlForMobile,
  checkInventoryType,
} from "../../../helpers/inventory";
import { getReceiveIntroDescriptionText } from "../../../helpers/getPropertyIcons";
import PhotoGalleryMob from "../../../components/Common/PhotoGalleryMob";
import { MESSAGES_VIEW } from "../../../constants/onBoarding";
import noImage from "../../../images/no-image-placeholder.png";
import { usePremium } from "@/hooks";
import BackLinkButton from "../../components/BackLinkButton";

const IntroductionDetails = (props) => {
  const { setUIKey, setIntroductionPhotos } = props;

  const navigate = useNavigate();
  useEffect(() => {
    document.body.classList.add("bg-offcanvas-fix");
  }, []);

  const [showAgentProfileInfoModal, setShowAgentProfileInfoModal] =
    useState(false);
  const AgentProfileInfoModalClose = () => setShowAgentProfileInfoModal(false);
  const AgentProfileInfoModalShow = () => setShowAgentProfileInfoModal(true);

  const [showExpireModal, setExpireModal] = useState(false);
  const expireModalClose = () => setExpireModal(false);

  const { shouldToggleColor } = usePremium();

  const [timeOutStatus, setTimeOutStatus] = useState(false);

  const [inventoryDetails, setInventoryDetails] = useState();
  const photos = _.get(inventoryDetails, "photos", []).filter(
    (item) => item.IsValid != 0,
  );
  const Sub_PropertyTypeId = convertToNumber(
    _.get(inventoryDetails, "Sub_PropertyTypeId", ""),
  );
  const propertyPurpose = getPropertyPurpose(
    _.get(inventoryDetails, "Is_Seller", ""),
    _.get(inventoryDetails, "Is_ShortTerm_Renter", ""),
    _.get(inventoryDetails, "Is_LongTerm_Renter", ""),
  );

  const invType = checkInventoryType(propertyPurpose);
  const nice2Have = _.get(inventoryDetails, "nice2Have", []);
  const mapImg = _.get(inventoryDetails, "Location_Img", "");
  const highSchool = _.get(inventoryDetails, "HighSchool", null);
  const neighborHood = _.get(inventoryDetails, "NeighborHood", null);
  const description = _.get(inventoryDetails, "Add_Details", "");
  const isAgent = _.get(inventoryDetails, "UserTypeId", "") === USER_TYPE_AGENT;
  const firstName = _.get(inventoryDetails, "FirstName", "");
  const lastName = _.get(inventoryDetails, "LastName", "");
  const lat = _.get(inventoryDetails, "Latitude", null);
  const lng = _.get(inventoryDetails, "Longitude", null);
  const fullName = firstName + " " + lastName;
  const introductionId = props.introductionId;
  const introAcceptedDate = _.get(inventoryDetails, "Accept_Date", "");
  const userId = getUserId();
  const userDeleted = location.state && location.state["userDeleted"];
  const isNiceToHaveExist = nice2Have.length > 0;
  const typeBasedOnProperty =
    Sub_PropertyTypeId === IS_LAND ? INVENTORY_LAND : invType;

  let titleText = "";
  switch (invType) {
    case INVENTORY_SELL:
      titleText = " selling";
      break;
    case INVENTORY_LTR:
      titleText = " renting";
      break;
    case INVENTORY_STR:
      titleText = " renting";
      break;
    case INVENTORY_LTR_STR:
      titleText = " renting";
      break;
    case INVENTORY_SELL_LTR:
      titleText = " selling, renting";
      break;
    case INVENTORY_SELL_STR:
      titleText = " selling, renting";
      break;
    default:
      titleText = " selling, renting";
      break;
  }

  useEffect(() => {
    if (!introductionId) {
      navigate(pageURLs.home);
    }
    getInventoryDetails(introductionId);
  }, []);

  const getInventoryDetails = async (introductionId) => {
    if (introductionId) {
      await getIntroductionInventoryDetailsById(introductionId)
        .then((response) => {
          const responseResult = _.get(response, "result", null);
          if (response.errorCode === 0 && responseResult) {
            setInventoryDetails(responseResult);
            setIntroductionPhotos(responseResult?.photos);
          } else {
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    } else {
      navigate(pageURLs.home);
    }
  };

  const [then, SetThen] = useState("");
  const countDown = (introAccepted72 = "") => {
    let datevalue = introAccepted72 ? introAccepted72 : then;
    var ms = moment(
      moment(new Date(datevalue), "DD/MM/YYYY HH:mm:ss").diff(
        moment(new Date(), "DD/MM/YYYY HH:mm:ss"),
      ),
    );
    var d = moment.duration(ms);

    var s = Math.floor(d.asHours()) + moment.utc(ms).format(":mm:ss");
    if (Math.floor(d.asHours()) > 1) {
      return moment.utc(ms).format("mm") > 0
        ? {
            time: Math.floor(d.asHours()) + 1,
            type: "hours",
            timeInNumber: Math.floor(d.asHours()) + 1,
          }
        : {
            time: Math.floor(d.asHours()),
            type: "hours",
            timeInNumber: Math.floor(d.asHours()) + 1,
          };
    } else if (moment.utc(ms).format("mm") > 0) {
      return {
        time: moment.utc(ms).format(":mm"),
        type: "minutes",
        timeInNumber: moment.utc(ms).format("mm"),
      };
    } else if (moment.utc(ms).format("ss") > 0) {
      return {
        time: moment.utc(ms).format(":ss"),
        type: "seconds",
        timeInNumber: moment.utc(ms).format("ss"),
      };
    } else {
      return { time: 0, type: "", timeInNumber: 0 };
    }
  };

  const [timeAgo, setTimeAgo] = useState();

  useEffect(() => {
    if (
      timeAgo?.timeInNumber &&
      (timeAgo?.timeInNumber == 0 || timeAgo?.timeInNumber == "00")
    ) {
      props.timeOutStatus(true);
    } else {
      const interval = setInterval(() => setTimeAgo(countDown()), 1000);
      return () => clearInterval(interval);
    }
  }, [timeAgo, then]);

  useEffect(() => {
    let introAccepted72 = moment
      .utc(introAcceptedDate)
      .add(INTRODUCTION_EXPIRATION_TIME, "hours")
      .toISOString();

    if (introAccepted72) {
      if (new Date(introAccepted72) - new Date() > 0) {
        SetThen(introAccepted72);
        countDown(introAccepted72);
      } else {
        setTimeOutStatus(true);
      }
    }
  }, [introAcceptedDate]);

  /**
   * To load must haves
   * @returns
   */
  const loadDetails = () => {
    return buildReceiveIntroMustHaveHtmlForMobile({
      typeBasedOnProperty: typeBasedOnProperty,
      formValues: inventoryDetails,
    });
  };
  /**
   * To load nice to haves list
   * @param {*} niceToHave
   * @returns
   */
  const loadNiceToHaveList = (niceToHave) => {
    return niceToHave.map((n2h, index) => {
      const icon = _.get(n2h, "icon", "");

      return (
        <div className="property-tag-mobile mb-2" key={index}>
          <div className="tag-icon-mobile">
            <img src={icon ? require("../../../images/" + icon) : ""} alt="" />
          </div>
          <span>{_.get(n2h, "text", "")}</span>
        </div>
      );
    });
  };

  return (
    <div className="gitcha-main-wrapper view-client-wrap intro-preview-wrap pb-0">
      <div className="content-wrapper h-100 content-wrapper-h-102-percent">
        <div className="content-wrapper h-100 content-wrapper-h-102-percent">
          <TopHeader
            variant={"threeComp"}
            outerClassname="bg-white"
            topClassName="w-100 top-three-comp-headerborder"
            bottomClassName="w-100"
          >
            <BackLinkButton
              shouldToggleColor={shouldToggleColor}
              onClick={() => {
                setUIKey(MESSAGES_VIEW);
              }}
            />
            <div
              className={`w-100 text-center ${shouldToggleColor ? "heading-premium" : ""}`}
            >
              Property
            </div>
          </TopHeader>
        </div>
        <div className="home-layout-content">
          <div className="premium-content-wrapper bg-white">
            <div className="confirmation-top-sec">
              <div className="long-txt-fix">
                <h2>{_.get(inventoryDetails, "Location", "")}</h2>
              </div>
              <div className="property-details-mob mb-4">
                {getReceiveIntroDescriptionText(inventoryDetails)}
              </div>
            </div>
            <PhotoGalleryMob photos={photos} setUIKey={setUIKey} />

            <div className="represent-agent brdr-top-common-wrap">
              <h3> {isAgent ? "Agent Information" : "Owner Information"}</h3>
              <div className="agent-profile-information">
                {isAgent ? (
                  <div className="profile-details">
                    <div className="d-flex align-items-center">
                      {_.get(inventoryDetails, "Img", "") ? (
                        <span className="profile-pic">
                          <img
                            src={_.get(inventoryDetails, "Img", "") ?? noImage}
                            alt=""
                          />
                        </span>
                      ) : (
                        <div className="profile-placeholder-wrap profile-bg-orange flex-shrink-0">
                          {fullName.replace(/-/g, "").match(/\b(\w)/g)}
                        </div>
                      )}

                      <div className="profile-name">
                        <div className="title d-flex align-items-center">
                          <h2> {fullName}</h2>
                          {_.get(inventoryDetails, "PlanId", "") ===
                            AGENT_USER_MONTHLY_PRO_MEMBER ||
                            (_.get(inventoryDetails, "PlanId", "") ===
                              AGENT_USER_YEARLY_PRO_MEMBER && (
                              <span className="pro-blue-badge ms-2">PRO</span>
                            ))}
                        </div>
                        <p className="m-0">
                          Agent @ {_.get(inventoryDetails, "Company", "")}
                        </p>
                      </div>
                    </div>

                    {!userDeleted && (
                      <button
                        type="button"
                        className="btn btn-link"
                        onClick={AgentProfileInfoModalShow}
                      >
                        View Profile
                      </button>
                    )}
                  </div>
                ) : (
                  <div className="profile-details">
                    <div className="d-flex align-items-center">
                      {_.get(inventoryDetails, "Img", "") ? (
                        <span className="profile-pic">
                          <img
                            src={_.get(inventoryDetails, "Img", "") ?? noImage}
                            alt=""
                          />
                        </span>
                      ) : (
                        <div className="profile-placeholder-wrap profile-bg-orange">
                          {fullName.replace(/-/g, "").match(/\b(\w)/g)}
                        </div>
                      )}
                      <div className="profile-name">
                        <div className="title d-flex  flex-column mb-0">
                          <h2> {fullName}</h2>
                          <p className="m-0">Property Owner</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {_.get(inventoryDetails, "Message", "") && (
                  <div className="agent-bio">
                    <p className="m-0">
                      {" "}
                      {_.get(inventoryDetails, "Message", "")}
                    </p>
                  </div>
                )}
              </div>
            </div>

            <div className="musthave-wrap-mob brdr-top-common-wrap mb-3">
              <h3>Details</h3>
              <div className="row">{loadDetails()}</div>
            </div>
            {description && (
              <div className="musthave-wrap-mob brdr-top-common-wrap mb-3">
                <h3>Description</h3>
                <p>{description}</p>
              </div>
            )}

            {isNiceToHaveExist ? (
              <div className="nicetohave-wrap-mob brdr-top-common-wrap mb-4">
                <h2>Features</h2>
                {loadNiceToHaveList(nice2Have)}
              </div>
            ) : (
              <></>
            )}

            {buildSchoolNeigborhoodHtmlForMobile({
              mapImg: mapImg,
              highSchool: highSchool,
              neighborHood: neighborHood,
              coordinates: [lng, lat],
            })}

            {_.get(inventoryDetails, "TimeLineText", null) ||
            _.get(inventoryDetails, "Appraisal_on_File", false) ||
            _.get(inventoryDetails, "Inspection_Report", false) ||
            _.get(inventoryDetails, "Seller_Finance", false) ||
            _.get(inventoryDetails, "Flood_Certificate", false) ||
            _.get(inventoryDetails, "Floor_Plan", false) ||
            _.get(inventoryDetails, "Assumable_mortgage", false) ? (
              <div className="buyer-info-mob other-details brdr-top-common-wrap">
                <h3>Other Details</h3>
                <ul>

                  {_.get(inventoryDetails, "TimeLineText", null) ? (
                    <li>
                      <span className="list-icn-wrap-mob"></span>
                      Timeline: {_.get(inventoryDetails, "TimeLineText", null)}
                    </li>
                  ) : (
                    ""
                  )}

                  {_.get(inventoryDetails, "Appraisal_on_File", false) ? (
                    <li>
                      <span className="list-icn-wrap-mob"></span>
                      Appraisal on file
                    </li>
                  ) : (
                    ""
                  )}

                  {_.get(inventoryDetails, "Inspection_Report", false) ? (
                    <li>
                      <span className="list-icn-wrap-mob"></span>
                      Inspection report on file
                    </li>
                  ) : (
                    ""
                  )}

                  {_.get(inventoryDetails, "Seller_Finance", false) ? (
                    <li>
                      <span className="list-icn-wrap-mob"></span>
                      Seller finance available
                    </li>
                  ) : (
                    ""
                  )}
                  {_.get(inventoryDetails, "Flood_Certificate", false) ? (
                    <li>
                      <span className="list-icn-wrap-mob"></span>
                      Flood certificate available
                    </li>
                  ) : (
                    ""
                  )}

                  {_.get(inventoryDetails, "Floor_Plan", false) ? (
                    <li>
                      <span className="list-icn-wrap-mob"></span>
                      Floor plan on file
                    </li>
                  ) : (
                    ""
                  )}

                  {_.get(inventoryDetails, "Assumable_mortgage", false) ? (
                    <li>
                      <span className="list-icn-wrap-mob"></span>
                      Assumable mortgage
                    </li>
                  ) : (
                    ""
                  )}
                </ul>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>

      <AgentProfileInfoModal
        show={showAgentProfileInfoModal}
        onHide={AgentProfileInfoModalClose}
        userId={_.get(inventoryDetails, "Agent_User_Id", "")}
        isTitleShow={true}
      />

      <ExpiredModal
        show={
          (!_.get(inventoryDetails, "IsReplied", "") && timeOutStatus) ||
          _.get(inventoryDetails, "IsExpired", "") == 1
        }
        onHide={expireModalClose}
      />
    </div>
  );
};

export default IntroductionDetails;
